export const THEME_STORAGE_KEY = 'coreui-free-react-admin-template-theme'

export const APP_THEME = Object.freeze({
  dark: 0,
  light: 1,
  auto: 2,
})

export const getColorMode = (appTheme) => {
  const normalizedTheme = Number(appTheme)

  if (normalizedTheme === APP_THEME.light) return 'light'
  if (normalizedTheme === APP_THEME.auto) return 'auto'
  return 'dark'
}

export const applyAppTheme = (appTheme) => {
  const colorMode = getColorMode(appTheme)
  localStorage.setItem(THEME_STORAGE_KEY, colorMode)
  window.dispatchEvent(new CustomEvent('appThemeChanged', { detail: colorMode }))
  return colorMode
}
